import { createMuiTheme } from '@material-ui/core/styles';
import MontserratRegular from '../fonts/Montserrat-Regular.otf';

const montserrat = {
	fontFamily: 'Montserrat',
	fontStyle: 'normal',
	fontDisplay: 'swap',
	fontWeight: 400,
	src: `
	  local('Montserrat'),
	  local('Montserrat-Regular'),
	  url(${MontserratRegular}) format('opentype')
	`,
	unicodeRange:
		'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const values = {
	xs: 0,
	sm: 600,
	md: 960,
	lg: 1280,
	xl: 1920,
};

const theme = createMuiTheme({
	breakpoints: {
		keys: ['xs', 'sm', 'md', 'lg', 'xl'],
		up: key => `@media (min-width: ${values[key]}px)`,
	},
	spacing: factor => [0, 4, 8, 16, 32, 64][factor],
	palette: {
		primary: {
			main: '#b60037',
		},
		black: {
			main: '#424242',
		},
		grey: {
			main: '#9d9d9d',
		},
		orange: {
			main: '#ff7f41',
		},
		green: {
			main: '#77aa79',
		},
		yellow: {
			main: '#f0b13e',
		},
		blue: {
			main: '#5c7dca',
		},
		navy: {
			main: '#485084',
		},
	},
	typography: {
		fontFamily: 'Montserrat',
	},
	overrides: {
		MuiCssBaseline: {
			'@global': {
				'@font-face': [montserrat],
			},
		},
	},
});

export default theme;
